import React from "react";
import * as S from "./PageWrapper.style";
import { UpgradeButton } from "./UpgradeButton";
import { Notifications } from "~/components/notifications";
import { useMediaQuery } from "~/spocketUI/hooks/useMediaQuery";
import { PlansModal } from "~/components/plans/plansModal";
import { ResumeModal } from "~/components/resumeModal";

interface IProps {
  children: React.ReactNode;
  isGuest?: boolean;
}

export const PageWrapper: React.FC<IProps> = ({ children = null, isGuest }) => {
  const isSettingsPage = location.pathname.includes("settings");
  const isNotMobile = useMediaQuery("tablet");

  if (isGuest) {
    return (
      <>
        <S.PageWrapperFullscreen>
          <>{children}</>
        </S.PageWrapperFullscreen>
        <PlansModal />
        <ResumeModal />
      </>
    );
  }

  return (
    <S.PageWrapper
      padding={isSettingsPage ? "24px 25px 58px" : "24px 92px 58px"}>
      <S.PageHeader>
        <UpgradeButton />
        {isNotMobile ? <Notifications /> : null}
      </S.PageHeader>
      <S.PageMaxWidth>
        <>{children}</>
      </S.PageMaxWidth>
      <PlansModal />
      <ResumeModal />
    </S.PageWrapper>
  );
};
